import { TaskFilterOptions } from '@griply/types';
import { filterHabits, getWeekStartsOn } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

import { useHabits } from '../use-habits';

export const useFilteredHabits = (
  filters: TaskFilterOptions | TaskFilterOptions[],
) => {
  const today = useToday();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);
  const habits = useHabits({ includeDeleted: true });

  return useMemo(() => {
    const filtersArray = Array.isArray(filters) ? filters : [filters];
    return filterHabits({ habits, filters: filtersArray, weekStartsOn, today });
  }, [filters, habits, today, weekStartsOn]);
};
